/// <amd-module name="VSS/Redux/Deprecated/HubViewState/HubViewStateSaga" />
import { HubViewStateActions } from "VSS/Redux/Deprecated/HubViewState/HubViewStateActions";
import { createObservableSaga } from "VSS/Redux/Utils/ObservableUtils";
import { effects, SagaIterator } from "redux-saga";
import { FILTER_CHANGE_EVENT } from "VSSUI/Utilities/Filter";
import { IHubViewState } from "VSSUI/Utilities/HubViewState";

export function* hubViewStateSaga(hubViewState: IHubViewState): SagaIterator {
    // Seed the hub view state module with the initial state
    const { selectedPivot, filter, viewOptions } = hubViewState;
    yield effects.put(HubViewStateActions.initialize(selectedPivot.value, filter.getState(), viewOptions.getViewOptions()));

    yield effects.fork(createObservableSaga(hubViewState.filter, { [FILTER_CHANGE_EVENT]: HubViewStateActions.filterStateChanged }));
    yield effects.fork(createObservableSaga(hubViewState.selectedPivot, HubViewStateActions.currentPivotChanged));
    yield effects.fork(createObservableSaga(hubViewState.viewOptions, HubViewStateActions.viewOptionsChanged));
}
